export const generateKey = (query: Record<string, unknown>): string => {
  const sortedQuery = Object.keys(query)
    .sort()
    .reduce((obj, key) => {
      return { ...obj, [key]: query[key] };
    }, {});
  return JSON.stringify(sortedQuery);
};
